var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.createOpened
    ? _c(
        "w-modal",
        { attrs: { value: "" } },
        [
          _c("app-create-new-book-year-card", {
            on: {
              saved: function ($event) {
                return _vm.onBookYearSaved($event)
              },
              close: function ($event) {
                _vm.createOpened = false
              },
            },
          }),
        ],
        1
      )
    : _vm.createdBookYear != null
    ? _c(
        "w-modal",
        { attrs: { value: "" } },
        [
          _c("app-new-book-year-success-modal", {
            attrs: { year: _vm.createdBookYear },
            on: {
              close: function ($event) {
                _vm.createdBookYear = null
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }